import React from 'react';
import { LandingPageWrapper } from 'components/landing-page-wrapper/LandingPageWrapper';
import { Grid } from '@mui/material';
import { ContractsSharedStyles } from '../../lib';
import { ChainSelector } from 'components/chain-selector/ChainSelector';
import InvalidPermissionsDialog from 'components/invalid-permissions-dialog/InvalidPermissionsDialog';
import { GridSortModel } from '@mui/x-data-grid';
import { TabItemsType } from 'components/landing-page-wrapper/components/TabComponent';

interface ContractsPageWrapperProps {
    title: string;
    handleAddContract: () => void;
    rowsData: any[];
    isLoading: boolean;
    columns: any;
    handleRowClick: (row: any) => void;
    emptyStateIcon: string;
    emptyStateBodyMessage: string;
    tabItems: TabItemsType[];
    tabsContainerStyles: any;
    tabsStyles: any;
    tabItemStyles: any;
    tableHeight: number;
    onTabChange: (event: React.SyntheticEvent, newValue: any) => void;
    selectedTab: any;
    selectedChain: any;
    setSelectedChain: React.Dispatch<React.SetStateAction<any>>;
    displayPermissionDialog: boolean;
    setDisplayPermissionDialog: React.Dispatch<React.SetStateAction<boolean>>;
    isTabAndTableComponentVisible: boolean;
    sortModel?: GridSortModel;
}

export const ContractsPageWrapper = ({
    title,
    handleAddContract,
    rowsData,
    isLoading,
    columns,
    handleRowClick,
    emptyStateIcon,
    emptyStateBodyMessage,
    tabItems,
    tabsContainerStyles,
    tabsStyles,
    tabItemStyles,
    tableHeight,
    onTabChange,
    selectedTab,
    selectedChain,
    setSelectedChain,
    displayPermissionDialog,
    setDisplayPermissionDialog,
    isTabAndTableComponentVisible,
    sortModel,
}: ContractsPageWrapperProps): React.JSX.Element => {
    const handleDialogClose = (): void => {
        setDisplayPermissionDialog(false);
    };

    return (
        <>
            <LandingPageWrapper
                title={title}
                showAddButton={true}
                onAddButtonClick={handleAddContract}
                showRefreshButton={false}
                tableData={rowsData}
                isLoading={isLoading}
                columns={columns}
                getRowId={(row: any): string =>
                    selectedTab === 'Contracts'
                        ? row.id.toString()
                        : `${row.header?.id}-${row.timestamp}`
                }
                onRowClick={(row): void => {
                    handleRowClick(row);
                }}
                paginationPageSizeOptions={[25, 50, 100]}
                paginationPageSize={25}
                emptyStateIcon={emptyStateIcon}
                emptyStateBodyMessage={emptyStateBodyMessage}
                tabItems={tabItems}
                onTabChange={onTabChange}
                selectedTab={selectedTab}
                tabsStyles={tabsStyles}
                tabsContainerStyles={tabsContainerStyles}
                tabItemStyles={tabItemStyles}
                isSelectFieldEnabled={true}
                selectedChain={selectedChain}
                rowHeight={selectedTab !== 'Contracts' ? 107 : 52}
                autoRowHeight={selectedTab !== 'Contracts'}
                tableHeight={tableHeight}
                isTabAndTableComponentVisible={isTabAndTableComponentVisible}
                sortModel={sortModel}
                setSelectedChain={setSelectedChain}
            >
                <Grid sx={ContractsSharedStyles.chainSelectContainerStyles}>
                    <ChainSelector
                        selectedChain={selectedChain}
                        setSelectedChain={setSelectedChain}
                        text='Select a chain to see your contracts.'
                    />
                </Grid>
            </LandingPageWrapper>
            {displayPermissionDialog && (
                <InvalidPermissionsDialog
                    open={displayPermissionDialog}
                    onClose={handleDialogClose}
                />
            )}
        </>
    );
};
